export default __webpack_public_path__ + "static/map-4794f2d805864eb79f013b11d8a87296.png";